import { useState, useEffect } from 'react';

const BASE_URL = 'https://trading.godev.it'; // AGGIORNA con il tuo dominio

export default function Home() {
  const [results, setResults] = useState([]);
  const [capital, setCapital] = useState(1000);
  const [riskPercent, setRiskPercent] = useState(2);
  const [granularity, setGranularity] = useState('1H');
  const [singleCoin, setSingleCoin] = useState('');
  const [tradeHistory, setTradeHistory] = useState([]);
  const [newTrade, setNewTrade] = useState({ symbol: '', entry: '', exit_price: '', size: '', profitLoss: '' });
  const [chatMessage, setChatMessage] = useState('');
  const [chatResponses, setChatResponses] = useState([]);
  const [notification, setNotification] = useState('');
  const [showHistory, setShowHistory] = useState(false);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);

  const coins = ['BTCUSDT', 'ETHUSDT', 'BNBUSDT', 'LINKUSDT', 'SOLUSDT', 'DOGEUSDT', 'FETUSDT', 'CRVUSDT'];

  async function analyzeCoin(symbol = 'BTCUSDT') {
    const response = await fetch('https://trading-agent-pro.onrender.com/analyze', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ symbol, granularity })
    });
    const data = await response.json();
    const riskAmount = (capital * riskPercent) / 100;
    const stopLossDistance = Math.abs(data.entry_price - data.stop_loss);
    const tradeSize = stopLossDistance ? (riskAmount / stopLossDistance).toFixed(4) : 0;
    setResults(prevResults => [...prevResults, { ...data, tradeSize }]);
  }

  async function analyzeAllCoins() {
    setResults([]);
    coins.forEach(symbol => analyzeCoin(symbol));
  }

  async function loadMoreTrades() {
    if (loading) return;
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/get_trades.php?limit=10&offset=${offset}`);
      const newTrades = await response.json();
      setTradeHistory(prev => [...prev, ...newTrades]);
      setOffset(prev => prev + 10);
    } catch (error) {
      console.error('Errore caricamento trade:', error);
    }
    setLoading(false);
  }

  async function addTrade() {
    setTradeHistory(prev => [...prev, newTrade]);
    try {
      const response = await fetch(`${BASE_URL}/save_trade.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newTrade)
      });
      const result = await response.json();
      if (!result.success) {
        console.error('Errore salvataggio:', result.error);
      }
    } catch (error) {
      console.error('Errore connessione API:', error);
    }
    setNewTrade({ symbol: '', entry: '', exit_price: '', size: '', profitLoss: '' });
  }

  function handleNotification(msg) {
    setNotification(msg);
    setTimeout(() => setNotification(''), 3000);
  }

  async function sendMessageToChatAI(message) {
    const historyText = tradeHistory.map(t => `${t.symbol}: Entry ${t.entry}, Exit ${t.exit_price}, Size ${t.size}, P/L ${t.profitLoss}`).join('\n');
    const analysisText = results.map(r => `${r.symbol}: Entry ${r.entry_price}, SL ${r.stop_loss}, TP1 ${r.take_profit_1}`).join('\n');
    const systemPrompt = `Sei un assistente di trading. Questo è lo storico delle operazioni:\n${historyText}\nQueste sono le analisi correnti:\n${analysisText}`;
    const response = await fetch(`${BASE_URL}/proxy_chatgpt.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: [
          { role: 'system', content: systemPrompt },
          { role: 'user', content: message }
        ]
      })
    });
    const data = await response.json();
    const aiMessage = data.choices[0].message.content;
    setChatResponses(prev => [...prev, { user: message, ai: aiMessage }]);
  }

  useEffect(() => {
    analyzeAllCoins();
    loadMoreTrades();
    const interval = setInterval(analyzeAllCoins, 3600000);
    return () => clearInterval(interval);
  }, [granularity]);

  useEffect(() => {
    function handleScroll() {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
        loadMoreTrades();
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-8">Dashboard Crypto 🚀</h1>

        {notification && <div className="mb-4 bg-green-600 p-2 rounded">{notification}</div>}

        {/* Parametri capitale e rischio */}
        <div className="mb-4 flex justify-center gap-4">
          <div>
            <label>Capitale disponibile:</label>
            <input type="number" value={capital} onChange={(e) => setCapital(Number(e.target.value))} className="px-2 py-1 rounded text-black" />
          </div>
          <div>
            <label>% Rischio:</label>
            <input type="number" value={riskPercent} onChange={(e) => setRiskPercent(Number(e.target.value))} className="px-2 py-1 rounded text-black" />
          </div>
        </div>

        {/* Timeframe */}
        <div className="mb-4">
          <label>Timeframe:</label>
          <select value={granularity} onChange={(e) => setGranularity(e.target.value)} className="px-2 py-1 rounded text-black">
            <option value="15m">15 minuti</option>
            <option value="1H">1 ora</option>
            <option value="4H">4 ore</option>
            <option value="1D">1 giorno</option>
          </select>
        </div>

        {/* Analisi Coin */}
        <button onClick={analyzeAllCoins} className="px-4 py-2 bg-green-500 rounded hover:bg-green-600 mb-4">Analizza Tutte le Coin</button>

        <div className="mb-4">
          <input type="text" value={singleCoin} onChange={(e) => setSingleCoin(e.target.value)} className="px-2 py-1 rounded text-black" placeholder="Analizza singola coin" />
          <button onClick={() => analyzeCoin(singleCoin)} className="px-4 py-2 bg-blue-500 rounded hover:bg-blue-600 ml-2">Analizza</button>
        </div>

        {/* Tabella Risultati */}
        {results.length > 0 && (
          <table className="min-w-full divide-y divide-gray-700 mb-8">
            <thead>
              <tr>
                <th>Coin</th><th>Entry</th><th>Stop</th><th>TP1</th><th>TP2</th><th>Score</th><th>Size</th><th>Note</th>
              </tr>
            </thead>
            <tbody>
              {results.map((r, i) => (
                <tr key={i} className="bg-gray-800">
                  <td>{r.symbol}</td><td>{r.entry_price}</td><td>{r.stop_loss}</td><td>{r.take_profit_1}</td><td>{r.take_profit_2}</td><td>{r.trade_score}</td><td>{r.tradeSize}</td><td>{r.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Chat AI */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold mb-4">Chat AI 🤖</h2>
          <input type="text" value={chatMessage} onChange={(e) => setChatMessage(e.target.value)} className="px-4 py-2 rounded text-black mr-2" placeholder="Chiedi qualcosa alla AI..." />
          <button onClick={() => sendMessageToChatAI(chatMessage)} className="px-4 py-2 bg-purple-500 rounded hover:bg-purple-600">Invia</button>
          <div className="mt-4">
            {chatResponses.map((chat, idx) => (
              <div key={idx} className="bg-gray-800 p-4 mt-2 rounded text-left">
                <p><strong>Tu:</strong> {chat.user}</p>
                <p className="mt-2"><strong>AI:</strong> {chat.ai}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Storico Operazioni */}
        <button onClick={() => setShowHistory(!showHistory)} className="mt-8 px-6 py-3 bg-purple-500 rounded-lg hover:bg-purple-600">
          {showHistory ? "Nascondi Storico Operazioni" : "Mostra Storico Operazioni"}
        </button>

        {showHistory && (
          <div className="mt-8">
            <h2 className="text-2xl font-bold mb-4">Storico Operazioni 📋</h2>
            <div className="flex flex-wrap gap-2 justify-center mb-4">
              <input type="text" placeholder="Coin" value={newTrade.symbol} onChange={(e) => setNewTrade({ ...newTrade, symbol: e.target.value })} className="px-2 py-1 rounded text-black" />
              <input type="number" placeholder="Entry" value={newTrade.entry} onChange={(e) => setNewTrade({ ...newTrade, entry: e.target.value })} className="px-2 py-1 rounded text-black" />
              <input type="number" placeholder="Exit" value={newTrade.exit_price} onChange={(e) => setNewTrade({ ...newTrade, exit_price: e.target.value })} className="px-2 py-1 rounded text-black" />
              <input type="number" placeholder="Size" value={newTrade.size} onChange={(e) => setNewTrade({ ...newTrade, size: e.target.value })} className="px-2 py-1 rounded text-black" />
              <input type="number" placeholder="P/L" value={newTrade.profitLoss} onChange={(e) => setNewTrade({ ...newTrade, profitLoss: e.target.value })} className="px-2 py-1 rounded text-black" />
              <button onClick={addTrade} className="px-4 py-2 bg-green-600 rounded hover:bg-green-700">Aggiungi</button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
